import { render } from "./ggjxgrycgbd.vue?vue&type=template&id=41aaecd6&scoped=true&ts=true"
import script from "./ggjxgrycgbd.vue?vue&type=script&lang=ts"
export * from "./ggjxgrycgbd.vue?vue&type=script&lang=ts"

import "./ggjxgrycgbd.vue?vue&type=style&index=0&id=41aaecd6&lang=less&scoped=true"

import exportComponent from "E:\\operationmanual\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41aaecd6"]])

export default __exports__